<!--
input 에서 사용되는 검증기능 mixin
주문하기 > 구매단가 input 에서 사용되는데,
혹시 나중에 다른 곳에서 사용될 수 있을까봐 믹스인으로 분리함

-----------------------------------------
사용하는 컴포넌트에서 해야할 일

1. 아래 메소드 정의필요
 - getValidateValue() @return mixed
 - getValidateRules() @return approve모듈에서 사용하는 검증규칙 https://charlgottschalk.github.io/approvejs/docs/

-->
<script>
    export default {
        data: function () {

            return {
                // 검증 처리 상태, ing : 검증중, success : 성공, error : 오류
                validateState: '',

                // 에러메세지
                errorMsg: ''
            };
        },
        computed: {
            /**
             * 검증관련 클래스 명
             * */
            validateClass: function () {
                return {
                    'validate-error': this.validateState === 'error',
                    'validate-ing': this.validateState === 'ing',
                    'validate-success': this.validateState === 'success'
                }
            },
        },

        methods: {

            /**
             * 검증상태를 설정한다
             * @param state 상태
             *          - 'ing'
             *          - 'success'
             *          - 'error'
             * @param errmsg  오류메세지
             */
            setState: function (state, errmsg) {
                this.validateState = state;

                // 오류 메세지가 존재하고 오류상태일때만 메세지 설정
                if (errmsg && state === 'error') {
                    this.errorMsg = errmsg;
                } else {
                    this.errorMsg = '';
                }

                // 이벤트 발생
                this.$emit('validate', this.validateState, this.errorMsg);

            },

            /**
             * 검증 처리 Promise를 반환
             **/
            getValidatePromise: function () {
                return  new Promise((resolve, reject) => {
                    // 검증
                    //if (! rules.title) rules.title = cmp.label;
                    let result = approve.value(this.getValidateValue(), this.getValidateRules());

                    // 검증 결과처리
                    if (result.approved) {
                        resolve();
                    } else {
                        reject(result.errors[0]);// 첫번째 오류메세지 설정
                    }
                });

            },

            /**
             * 라이브검증 호출
             * debounce 처리되어 validate 호출
             */
            debounceValidate: _.debounce(function () {
                this.validate();
            }, 500),

            /**
             * 검증 실행
             */
            validate: function () {
                let cmp = this; // 뷰 컴포넌트 객체
                let value = cmp.getValidateValue(); // 검증이 이루어질 값, 추후에 검증과정중에 값이 변경되었는지 검사함.

                // 검증중 이면 먼저 검증이 끝날때까지 검증안함.
                if (this.validateState === 'ing') {
                    return;
                }
                cmp.setState('ing');

                // 검증 프라미스 실행
                let promise = this.getValidatePromise();
                promise.then(function () {
                    // resolve
                    cmp.setState('success');
                    //console.log('success');

                }, function (reason){
                    // reject
                    cmp.setState('error', reason);
                    //console.log('error');

                }).finally(function () {
                    //console.log('finally');
                    // 검증이 실행되는동안 값이 변경되었으면 검증을 다시 실행
                    if (value !== cmp.getValidateValue()) {
                        cmp.validate();
                    }

                });

            },

        },
    }
</script>